import React from 'react';
import PropTypes from 'prop-types';

import 'assets/scss/userDashboard.css';

const CategoriesList = ({ categories }) => (
  <div className="p-3 business-badge">
    {categories.map(category => (
      <span className="badge">{category.name}</span>
    ))}
  </div>
);

CategoriesList.defaultProps = {
  categories: [],
};

CategoriesList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
};

export default CategoriesList;



// WEBPACK FOOTER //
// ./src/components/businessDetail/categoriesList.js